import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { formatMultiplier, formatOdds, formatPercent } from './utils';

const buildDefaultMeta = (horse) =>
  `単勝 ${formatOdds(horse.odds)} / 勝率 ${formatPercent(horse.winRate, 1)} / 回収率 ${formatMultiplier(horse.expectedValue, 2)}`;

function AiRecommendedHorses({
  horses,
  eyebrow = 'AI RECOMMEND',
  title = 'AI推奨馬',
}) {
  return (
    <Box className="race-detail-panel race-detail-recommend-panel">
      <Typography className="race-detail-section-eyebrow">{eyebrow}</Typography>
      <Typography className="race-detail-section-title">{title}</Typography>

      <Stack spacing={1.5} sx={{ mt: 2.5 }}>
        {horses.map((horse) => (
          <Box
            key={horse.horseNumber}
            className={`race-detail-focus-card race-detail-recommend-card race-detail-recommend-card-${horse.aiRank.toLowerCase()}`}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography className="race-detail-focus-name">
                <span className="race-detail-horse-pill">{horse.horseNumber}</span>
                <span className="race-detail-focus-name-text">{horse.horseName}</span>
                <span className={`race-detail-inline-rank race-detail-rank-${horse.aiRank.toLowerCase()}`}>
                  {horse.aiRank}
                </span>
              </Typography>
              <Typography className="race-detail-focus-meta">{horse.metaText || buildDefaultMeta(horse)}</Typography>
            </Box>
            <Box className={`race-detail-rank-badge race-detail-rank-${horse.aiRank.toLowerCase()}`}>
              {horse.aiRank}
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

export default AiRecommendedHorses;
